// Backend manzili bitta joydan boshqariladi.
//
// Ishlab chiqishda (npm start) .env.development dagi REACT_APP_API_URL
// ishlatiladi — u localhost:3001 ga ishora qiladi.
//
// Serverda nginx admin panelni ham, /api ni ham bir xil manzildan uzatadi,
// shuning uchun nisbiy '/api' yetarli — server IP'si yoki domeni
// o'zgarsa ham kodga tegish shart emas.
export const API = process.env.REACT_APP_API_URL || '/api';
